module.exports = __webpack_public_path__ + "static/img/BUBLY_SMILE-COCOPINE.1b137ea.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/BUBLY_SMILE-COCOPINE.gif
// module id = m70B
// module chunks = 0